import React, { useEffect, useMemo, useState } from 'react';
import { useFormik } from 'formik';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import ViewChallengeDefault from './Default';
import ViewChallengePlayful from './Playful';

export function ViewChallenge(props) {
  const { selectedTab, challengeId, uri } = props;
  const [challenge, setChallenge] = useState([]);
  const [challengeData, setChallengeData] = useState();
  const [loading, setLoading] = useState(false);
  const [participantsLoading, setParticipantsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [challengeParticipants, setChallengeParticipants] = useState([]);
  const [orderByAccuracy, setOrderByAccuracy] = useState('ascendent');
  const client = useClient();
  const isPlayfulTeacherTheme = usePlayfulTeacher();

  const fetchData = async () => {
    const fetchChallenge = client.fetch(`challenges/${challengeId}`);
    const fetchChallengeData = client.fetch(`/challenges/${challengeId}/question_accuracy`);
    setLoading(true);
    const [dataResponse, challengeResponse] = await Promise.allSettled([fetchChallengeData, fetchChallenge]);

    if (dataResponse.status === 'rejected' || dataResponse.value.error) {
      toast.error('Erro ao buscar dados do desafio');
    } else {
      setChallengeData(dataResponse.value.data.data.map(item => ({ label: item.taxonomy, value: item['question-accuracy'] })));
    }
    if (challengeResponse.status === 'rejected' || challengeResponse.value.error) {
      toast.error('Erro ao buscar desafio');
    } else {
      setChallenge(challengeResponse.value.data);
    }
    setLoading(false);
  };

  const fetchChallengeRanking = async () => {
    setParticipantsLoading(true);
    const { data, error } = await client.fetch(`/challenges/${challengeId}/student_results?page[number]=${pageNumber}&page[size]=10`);
    if (error) {
      toast.error('Erro ao buscar participantes');
      setHasMore(false);
    } else {
      if (data.data.length === 0) {
        setHasMore(false);
      }
      setChallengeParticipants(prevState => [...prevState, ...data.data]);
    }
    setParticipantsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchChallengeRanking();
  }, [pageNumber]);

  const filters = useFormik({
    initialValues: {
      searchTerm: ''
    }
  });

  const filteredParticipants = useMemo(() => {
    const newArr = challengeParticipants?.filter(item => !filters.values.searchTerm || item.name.toLowerCase().includes(filters.values.searchTerm.toLowerCase()));
    return newArr;
  }, [challengeParticipants, filters.values.searchTerm]);

  const orderedParticipants = useMemo(() => {
    let newArr;
    if (orderByAccuracy === 'descendent') {
      newArr = filteredParticipants.sort((a, b) => a['accuracy-rate'] - b['accuracy-rate']);
    } else {
      newArr = filteredParticipants.sort((a, b) => b['accuracy-rate'] - a['accuracy-rate']);
    }

    return newArr;
  }, [orderByAccuracy, filteredParticipants]);

  const viewProps = {
    selectedTab,
    uri,
    challengeId,
    challenge,
    challengeData,
    challengeParticipants,
    loading,
    participantsLoading,
    participants: orderedParticipants,
    filters,
    orderByAccuracy,
    setOrderByAccuracy,
    hasMore,
    setPageNumber
  };

  return isPlayfulTeacherTheme ? <ViewChallengePlayful {...viewProps} /> : <ViewChallengeDefault {...viewProps} />;
}
